// src/components/Dashboard/ServicesAdmin.jsx
import React, { useState } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiSave, FiX } from 'react-icons/fi';
import './ServicesAdmin.css';

function ServicesAdmin() {
  // Başlangıçta liste tamamen boş, her şeyi sıfırdan panelden ekleyeceğiz kanka
  const [services, setServices] = useState([]);

  const [isEditing, setIsEditing] = useState(false);
  const [currentService, setCurrentService] = useState({
    id: '',
    title: '',
    subtitle: '',
    desc1: '',
    desc2: '',
    processTitle: '',
    processDesc: '',
    listText: ''
  });

  // Düzenleme modunu açma
  const handleEditClick = (service) => {
    setIsEditing(true);
    setCurrentService({
      ...service,
      listText: Array.isArray(service.list) ? service.list.join('\n') : service.listText || ''
    });
  };

  // Yeni ekleme modu açma
  const handleAddNew = () => {
    setIsEditing(true);
    setCurrentService({
      id: '',
      title: '',
      subtitle: '',
      desc1: '',
      desc2: '',
      processTitle: '',
      processDesc: '',
      listText: ''
    });
  };

  // Kaydetme (Ekleme veya Güncelleme)
  const handleSave = (e) => {
    e.preventDefault();

    // Alt maddeleri alt alta yazılan metinden diziye (array) çeviriyoruz
    const formattedList = currentService.listText
      ? currentService.listText.split('\n').filter(item => item.trim() !== '')
      : [];

    const serviceDataToSave = {
      ...currentService,
      id: currentService.id || currentService.title.toLowerCase().replace(/ /g, '-').replace(/[ığüşöç]/g, (v) => {
        return {'ı':'i', 'ğ':'g', 'ü':'u', 'ş':'s', 'ö':'o', 'ç':'c'}[v];
      }),
      list: formattedList
    };

    if (services.some(s => s.id === serviceDataToSave.id)) {
      // Güncelle
      setServices(services.map(s => s.id === serviceDataToSave.id ? serviceDataToSave : s));
    } else {
      // Yeni Ekle
      setServices([...services, serviceDataToSave]);
    }

    setIsEditing(false);
    setCurrentService({
      id: '',
      title: '',
      subtitle: '',
      desc1: '',
      desc2: '',
      processTitle: '',
      processDesc: '',
      listText: ''
    });
  };

  // Silme
  const handleDelete = (id) => {
    if (window.confirm("Bu çalışma alanını silmek istediğinize emin misiniz?")) {
      setServices(services.filter(s => s.id !== id));
    }
  };

  return (
    <div className="services-admin-container">
      <div className="admin-section-header">
        <h3>Çalışma Alanları Yönetimi</h3>
        <button className="add-btn" onClick={handleAddNew}>
          <FiPlus /> Yeni Çalışma Alanı Ekle
        </button>
      </div>

      {/* Ekleme / Düzenleme Formu */}
      {isEditing && (
        <form onSubmit={handleSave} className="service-form-card">
          <h4>{currentService.id ? 'Çalışma Alanını Düzenle' : 'Yeni Çalışma Alanı Ekle'}</h4>
          <div className="form-grid">
            <div className="form-group">
              <label>Çalışma Alanı Başlığı *</label>
              <input 
                type="text" 
                placeholder="Örn: Ceza Hukuku" 
                value={currentService.title}
                onChange={(e) => setCurrentService({ ...currentService, title: e.target.value })}
                required 
              />
            </div>

            <div className="form-group">
              <label>Alt Başlık / Slogan *</label>
              <input 
                type="text" 
                placeholder="Örn: Kişi Hak ve Özgürlüklerinizin En Güçlü Savunması" 
                value={currentService.subtitle}
                onChange={(e) => setCurrentService({ ...currentService, subtitle: e.target.value })}
                required 
              />
            </div>

            <div className="form-group">
              <label>1. Paragraf (Ana Açıklama) *</label>
              <textarea 
                placeholder="Detay sayfasındaki ilk paragraf..." 
                value={currentService.desc1}
                onChange={(e) => setCurrentService({ ...currentService, desc1: e.target.value })}
                rows="3"
                required 
              ></textarea>
            </div>

            <div className="form-group">
              <label>2. Paragraf (İsteğe Bağlı Ek Açıklama)</label>
              <textarea 
                placeholder="Detay sayfasındaki ikinci paragraf..." 
                value={currentService.desc2}
                onChange={(e) => setCurrentService({ ...currentService, desc2: e.target.value })}
                rows="3"
              ></textarea>
            </div>

            <div className="form-group">
              <label>Süreç Kutusu Başlığı *</label>
              <input 
                type="text" 
                placeholder="Örn: Ceza Yargılamasında Nasıl Çalışıyoruz?" 
                value={currentService.processTitle}
                onChange={(e) => setCurrentService({ ...currentService, processTitle: e.target.value })}
                required 
              />
            </div>

            <div className="form-group">
              <label>Süreç Kutusu Açıklaması *</label>
              <textarea 
                placeholder="Süreç yönetiminin açıklaması..." 
                value={currentService.processDesc}
                onChange={(e) => setCurrentService({ ...currentService, processDesc: e.target.value })}
                rows="2"
                required 
              ></textarea>
            </div>

            <div className="form-group">
              <label>Başlıca Hizmetler (Her satıra bir madde yazın) *</label>
              <textarea 
                placeholder="Ağır Ceza Mahkemesi Davaları&#10;Asliye Ceza Mahkemesi Davaları&#10;İstinaf ve Yargıtay Başvuruları" 
                value={currentService.listText}
                onChange={(e) => setCurrentService({ ...currentService, listText: e.target.value })}
                rows="5"
                required 
              ></textarea>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="save-btn"><FiSave /> Kaydet</button>
            <button type="button" className="cancel-btn" onClick={() => setIsEditing(false)}><FiX /> İptal</button>
          </div>
        </form>
      )}

      {/* Kayıtlı Alanlar Listesi */}
      <div className="services-list-grid">
        {services.length === 0 ? (
          <p className="no-services-text" style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '30px' }}>
            Henüz hiç çalışma alanı eklenmedi. Yukarıdaki butona tıklayarak ilk alanı ekleyebilirsin.
          </p>
        ) : (
          services.map((service) => (
            <div key={service.id} className="admin-service-card">
              <div className="service-info">
                <h4>{service.title}</h4>
                <p><strong>Alt Başlık:</strong> {service.subtitle}</p>
                <p><strong>Hizmet Sayısı:</strong> {service.list ? service.list.length : 0} madde</p>
                <span className="service-id-badge">ID: {service.id}</span>
              </div>
              <div className="service-actions">
                <button className="edit-btn" onClick={() => handleEditClick(service)}><FiEdit2 /></button>
                <button className="delete-btn" onClick={() => handleDelete(service.id)}><FiTrash2 /></button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ServicesAdmin;